import { render } from "./PointOutcomeOverlay.vue?vue&type=template&id=6dae658b&scoped=true"
import script from "./PointOutcomeOverlay.vue?vue&type=script&lang=js"
export * from "./PointOutcomeOverlay.vue?vue&type=script&lang=js"

import "./PointOutcomeOverlay.vue?vue&type=style&index=0&id=6dae658b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dae658b"]])

export default __exports__